import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';

// Configure AWS Amplify
try {
  Amplify.configure(awsconfig);
  console.log('✅ AWS Amplify configured successfully');
} catch (error) {
  console.error('❌ AWS Amplify configuration failed:', error);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();